import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import snakeToTitleCase from "./utils/SnakeToTitleCase";
import { capitalize } from "lodash";

const ClaimSearch = (props) => {
  const [networkOptions, setNetworkOptions] = useState(
    props.networks[props.params?.manufacturer] || []
  );
  const [network, setNetwork] = useState(props.params.network || "");

  const handleManufacturerChange = (e) => {
    const selectedManufacturer = e.target.value;
    const options = props.networks[selectedManufacturer] || [];
    setNetworkOptions(options);
  };

  return (
    <React.Fragment>
      <div className="pt-3 pb-1">
        <h1 className="h2">
          <i className="fa fa-envelopes-bulk pe-2"></i>
          {capitalize(props.claimType)} Submission Claims
          {props.params?.manufacturer && (
            <div className="badge text-muted bg-light ms-2 fw-normal">
              {props.manufacturer_names[props.params.manufacturer]}
            </div>
          )}
        </h1>
      </div>
      <p className="text-muted">
        Submitted covered entity claims of contract pharmacy transactions eligible for 340B pricing.
      </p>
      <div className="jumbotron p-4 mb-3 bg-body-tertiary rounded-4">
        <Form method="GET">
          <div className="row">
            <Form.Group controlId="id340b" className="col-sm-4">
              <Form.Label>
                340B ID <small className="text-danger">* Required</small>
              </Form.Label>
              <Form.Control
                required
                className="input-lg"
                type="text"
                placeholder="Enter 340B ID..."
                name="id_340b"
                defaultValue={props.params.id_340b}
                autoFocus={true}
              />
            </Form.Group>
            <Form.Group controlId="manufacturer" className="col-sm-4">
              <Form.Label>Manufacturer</Form.Label>
              <Form.Select
                className="select-lg"
                name="manufacturer"
                defaultValue={props.params.manufacturer}
                onChange={handleManufacturerChange}
              >
                <option value="">All Manufacturers</option>
                {props.manufacturers.map((manufacturer) => (
                  <option key={manufacturer} value={manufacturer}>
                    {props.manufacturer_names[manufacturer]}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group controlId="network" className="col-sm-4">
              <Form.Label>Network</Form.Label>
              <Form.Select
                name="network"
                className="select-lg"
                value={network}
                onChange={(e) => setNetwork(e.target.value)}
              >
                <option value="">All Networks</option>
                {networkOptions.map((networkOption) => (
                  <option key={networkOption} value={networkOption}>
                    {snakeToTitleCase(networkOption)}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="col-sm-4">
              <br />
              <Button className="mt-2" variant="primary" type="submit">
                Search {props.claimType} Claims
              </Button>
            </Form.Group>
          </div>
        </Form>
      </div>
    </React.Fragment>
  );
};

export default ClaimSearch;
